import React from 'react';
import c from 'classnames';

import { SearchPagination } from '@uncinc/react-searchkit';

import Icon from '../../Icon';

export interface SearchForumThreadPaginationProps {
  className?: string;
}

const SearchForumThreadPagination: React.FC<SearchForumThreadPaginationProps> = (props) => {
  const { className } = props;

  const classNames = c('SearchForumThread__Pagination', className);

  return (
    <div className={classNames}>
      <SearchPagination
        pageRangeDisplayed={3}
        previousLabel={(
          <Icon icon="chevron" orientation="left" />
        )}
        nextLabel={(
          <Icon icon="chevron" />
        )}
      />
    </div>
  );
};

export default SearchForumThreadPagination;
